<template>
  <ion-page>
    <ion-content
      :class="[isMobile ? 'main-background account-content' : 'liga-web-background account-content account-content--web']"
      :fullscreen="true"
      :scroll-y="true"
    >
      <div class="account-page-body">
      <div class="logo">
        <img src="@/theme/liga-logo-white.png" alt="liga-logo" />
      </div>
      <h1 class="ion-text-center white-bold">ЛИЧНЫЙ КАБИНЕТ</h1>
      <ion-avatar @click="loadAvatar()">
        <ion-icon :icon="cameraOutline" v-show="avatarUrl.length < 1"></ion-icon>
        <ion-img :src="avatarUrl" v-show="avatarUrl.length > 1"></ion-img>
      </ion-avatar>
      <div class="ion-text-center white-regular username">
        {{ lastname }} {{ firstname }}
      </div>
      <div class="account-info ion-margin-top">
        <div class="account-item">
          <div class="account-item-label dark-bold">Логин</div>
          <div class="account-item-value dark-regular">{{ username }}</div>
        </div>
        <div class="account-item">
          <div class="account-item-label dark-bold">E-mail</div>
          <div class="account-item-value dark-regular">{{ email }}</div>
        </div>
        <div class="account-item account-item-icon">
          <div class="account-item-label dark-bold">Пароль</div>
          <div class="account-item-value dark-regular">******</div>
          <ion-icon :icon="keyOutline" class="password-icon" @click="changePassword()"></ion-icon>
        </div>

        <div class="account-item account-item-privacy">
          <span class="account-item-label dark-bold">Политика конфиденциальности</span>
          <ion-button fill="outline" size="small" color="medium" class="privacy-link-btn" @click="$router.push('/privacy-policy')">
            Открыть
          </ion-button>
        </div>
        <div class="account-item account-item-consent" v-if="privacyConsentAccepted !== null">
          <div class="account-item-label dark-bold">Согласие с условиями</div>
          <div class="account-item-value dark-regular">{{ privacyConsentAccepted ? 'Принято' : 'Не принято' }}</div>
        </div>

        <div class="account-sessions-block">
          <div class="account-item-label white-bold account-sessions-title">Авторизации на устройствах ({{ sessions.length }})</div>
          <p v-if="sessionsLoading" class="account-sessions-hint">Загрузка…</p>
          <div v-else-if="sessions.length" class="account-sessions-list">
            <div v-for="s in sessions" :key="s.id" class="account-session-item">
              <div class="account-session-info">
                <span class="account-session-device">{{ s.deviceName || 'Устройство' }}</span>
                <span class="account-session-date">{{ formatSessionDate(s.createdAt) }}</span>
              </div>
              <ion-button fill="clear" size="small" color="medium" class="account-session-revoke" @click="revokeSession(s.id)">
                Выйти с устройства
              </ion-button>
            </div>
          </div>
          <p v-else class="account-sessions-hint">Нет активных авторизаций</p>
        </div>

        <ion-button v-on:click="signOut()">Выход</ion-button>

        <ion-button fill="outline" color="danger" v-on:click="confirmDeleteAccount()" class="delete-account-button">
          Удалить аккаунт
        </ion-button>
      </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { GlobalContext } from "@/model/globalcontext.model";
import { ligaAccount } from "@/model/ligaaccount.model";
import AccountService from "@/services/account.service";
import store from "@/store/index";
import { clearClientSessionAndRedirectGuest } from "@/utils/auth-session-clear";
import { Camera, CameraResultType, Photo } from "@capacitor/camera";
import { Capacitor, CapacitorHttp } from "@capacitor/core";
import {
    Directory,
    Encoding,
    Filesystem,
    ReadFileResult,
} from "@capacitor/filesystem";
import { Preferences } from "@capacitor/preferences";
import {
    IonAvatar,
    IonButton,
    IonContent,
    IonIcon,
    IonImg,
    IonPage,
    alertController,
} from "@ionic/vue";
import dayjs from "dayjs";
import { cameraOutline, keyOutline } from "ionicons/icons";
import { defineComponent, inject } from "vue";

export default defineComponent({
  name: "Account",
  components: {
    IonContent,
    IonPage,
    IonAvatar,
    IonButton,
    IonIcon,
    IonImg,
  },
  setup() {
    const AVATAR_FILE_NAME = "liga-avatar.jpeg";
    const globalContext = inject("globalContext") as GlobalContext;
    const isMobile = globalContext.isMobile;
    const accountService = new AccountService(globalContext);

    return {
      cameraOutline,
      keyOutline,
      AVATAR_FILE_NAME,
      isMobile,
      globalContext,
      accountService,
    };
  },
  data() {
    return {
      username: store.getters.account ? store.getters.account.login : "",
      firstname: store.getters.account ? store.getters.account.firstName : "",
      lastname: store.getters.account ? store.getters.account.lastName : "",
      email: store.getters.account ? store.getters.account.email : "",
      userId: store.getters.account
        ? Number(store.getters.account.id)
        : Number(-1),
      avatarUrl: "",
      ligaAccount: new ligaAccount(-1),
      privacyConsentAccepted: null as boolean | null,
      sessions: [] as { id: number; deviceName: string; createdAt: string; lastUsedAt: string | null }[],
      sessionsLoading: false,
    };
  },
  ionViewWillEnter() {
    this.username = store.getters.account ? store.getters.account.login : "";
    this.firstname = store.getters.account ? store.getters.account.firstName : "";
    this.lastname = store.getters.account ? store.getters.account.lastName : "";
    this.email = store.getters.account ? store.getters.account.email : "";
    Preferences.get({ key: "privacy_consent_accepted" }).then((res) => {
      this.privacyConsentAccepted = res.value === "true";
    });

    Filesystem.readdir({
      path: "",
      directory: Directory.Data,
    }).then((response) => {
      const avatarFile = response.files.find((f) => {
        return f.name == this.AVATAR_FILE_NAME;
      });
      if (undefined !== avatarFile) {
        Filesystem.getUri({
          path: this.AVATAR_FILE_NAME,
          directory: Directory.Data,
        }).then((res) => {
          if (res.uri !== "")
            this.avatarUrl = Capacitor.convertFileSrc(res.uri);
        });
      }
    });

    if (!this.globalContext.offlineMode) {
      this.loadligaAccount(this.userId);
      this.loadSessions();
    }
  },

  computed: {
    medicalDateFormated(): string {
      return this.ligaAccount
        ? dayjs(this.ligaAccount.medicalBookDate).format("DD.MM.YYYY")
        : "Нет информации";
    },
    contractDays(): number {
      return this.ligaAccount && this.ligaAccount.contractStartDate
        ? dayjs().diff(this.ligaAccount.contractStartDate, "day")
        : 0;
    },
  },

  methods: {
    async showAlert(alertTitle: string, alertMessage: string) {
      const alert = await alertController.create({
        header: alertTitle,
        message: alertMessage,
        buttons: ["OK"],
      });

      await alert.present();
    },

    formatSessionDate(iso: string): string {
      if (!iso) return "";
      return dayjs(iso).format("DD.MM.YYYY HH:mm");
    },

    async loadSessions() {
      if (this.globalContext?.offlineMode) return;
      this.sessionsLoading = true;
      try {
        await this.accountService.ensureSession();
        this.sessions = await this.accountService.getSessions();
      } catch {
        this.sessions = [];
      } finally {
        this.sessionsLoading = false;
      }
    },

    async revokeSession(sessionId: number) {
      try {
        const ok = await this.accountService.revokeSession(sessionId);
        if (ok) {
          this.sessions = this.sessions.filter((s) => s.id !== sessionId);
        } else {
          await this.showAlert("Ошибка", "Не удалось завершить сессию.");
        }
      } catch (e) {
        console.error("revokeSession", e);
        await this.showAlert("Ошибка", "Не удалось завершить сессию.");
      }
    },

    signOut() {
      void clearClientSessionAndRedirectGuest(false, 'login');
    },

    changePassword() {
      this.$router.push("/change-password");
    },

    async confirmDeleteAccount() {
      const alert = await alertController.create({
        header: 'Удаление аккаунта',
        message: 'Вы уверены, что хотите удалить свой аккаунт? Это действие нельзя отменить. Все ваши данные будут удалены.',
        buttons: [
          {
            text: 'Отмена',
            role: 'cancel',
            cssClass: 'secondary',
          },
          {
            text: 'Удалить',
            role: 'destructive',
            handler: () => {
              this.deleteAccount();
            },
          },
        ],
      });

      await alert.present();
    },

    async deleteAccount() {
      try {
        const success = await this.accountService.deleteAccount();
        if (success) {
          // Redirect to login after successful deletion
          this.$router.replace('/login');
        } else {
          await this.showAlert(
            'Ошибка',
            'Не удалось удалить аккаунт. Пожалуйста, попробуйте позже.'
          );
        }
      } catch (error) {
        console.error('Error deleting account:', error);
        await this.showAlert(
          'Ошибка',
          'Произошла ошибка при удалении аккаунта. Пожалуйста, попробуйте позже.'
        );
      }
    },

    async loadAvatar() {
      const cameraPermissions = await Camera.checkPermissions();
      if (
        cameraPermissions.photos.toString() !== "granted" ||
        cameraPermissions.camera.toString() !== "granted"
      ) {
        const requestCameraPermissions = await Camera.requestPermissions();
        if (
          requestCameraPermissions.photos.toString() !== "granted" ||
          requestCameraPermissions.camera.toString() !== "granted"
        ) {
          this.showAlert(
            "Отмена",
            "Необходимо предоставить доступ приложению к камере и фото."
          );
          return;
        }
      }
      const image = await Camera.getPhoto({
        quality: 90,
        allowEditing: true,
        resultType: CameraResultType.Uri,
      });
      this.savePicture(image, this.AVATAR_FILE_NAME).then(async (res) => {
        this.avatarUrl = res.webviewPath ? res.webviewPath : "";
      });
    },

    async loadligaAccount(userId: number) {
      const tokenQuery = await Preferences.get({ key: "jwt" });
      const token = tokenQuery.value;

      const options = {
        url: `${process.env.VUE_APP_API_URL}api/liga-accounts/user/${userId}`,
        headers: { Authorization: `Bearer ${token}` },
        readTimeout: 60000,
      };

      await CapacitorHttp.get(options)
        .then((response) => {
          if (response) {
            this.ligaAccount = response.data;
          }
        })
        .catch(() => {
          console.error("Failed to load liga account");
        });
    },

    async base64FromPath(path: string): Promise<string> {
      const response = await fetch(path);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => {
          if (typeof reader.result === "string") {
            resolve(reader.result);
          } else {
            reject("method did not return a string");
          }
        };
        reader.readAsDataURL(blob);
      });
    },

    async savePicture(photo: Photo, fileName: string) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const base64Data = await this.base64FromPath(photo.webPath!);
      let fsPermissions = false;
      await Filesystem.checkPermissions().then(async (res) => {
        if (res.publicStorage.toString() !== "granted") {
          Filesystem.requestPermissions().then(async (res) => {
            if (res.publicStorage.toString() !== "granted") {
              return;
            }
          });
        } else {
          fsPermissions = true;
        }
        if (fsPermissions) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          await Filesystem.writeFile({
            path: fileName,
            data: base64Data,
            directory: Directory.Data,
          });
        }
      });

      return {
        filepath: fileName,
        webviewPath: photo.webPath,
      };
    },

    async readFile(fileName: string): Promise<ReadFileResult> {
      const contents = await Filesystem.readFile({
        path: fileName,
        directory: Directory.Data,
        encoding: Encoding.UTF8,
      });

      return contents;
    },
  },
});
</script>

<style scoped>
.account-page-body {
  width: 100%;
  box-sizing: border-box;
}

.account-content--web .account-page-body {
  max-width: 480px;
  margin: 0 auto;
  padding: 24px 20px 48px;
}

.logo {
  margin: 2vh 1vw -5vh 0;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  min-height: 80px;
}

.logo img {
  width: 220px;
}

h1 {
  letter-spacing: 0.08em;
}

ion-avatar {
  background: white;
  margin: auto;
  margin-top: 2em;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-avatar ion-icon {
  color: white;
  font-size: 2em;
}

.username {
  margin-top: 1em;
  letter-spacing: 0.08em;
}

.account-info {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 2em;
}

.account-item {
  background-color: white;
  border-radius: 10px;
  width: min(420px, 90vw);
  max-width: 100%;
  min-height: 2em;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 0.2em 1em 0.2em 1em;
  margin-bottom: 1em;
  opacity: 0.95;
}

.account-content--web .account-item,
.account-content--web .account-sessions-block {
  width: 100%;
}

.account-item-icon {
  justify-content: space-between;
}

.account-item-label {
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 0.8em;
  font-weight: bold;
}

.account-item-value {
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 0.8em;
  letter-spacing: 0.08em;
  margin-left: 2em;
}

ion-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  width: 280px;
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
}

.delete-account-button {
  --background: transparent;
  --border-color: var(--ion-color-danger);
  --color: var(--ion-color-danger);
  --border-width: 2px;
  margin-top: 1em;
}

.password-icon {
  color: var(--ion-color-orange);
  margin-left: auto;
  flex-shrink: 0;
}

.account-item-privacy,
.account-item-consent {
  justify-content: space-between;
  min-height: 2.5em;
}
.account-item-privacy .account-item-label {
  flex: 1;
  margin-right: 8px;
}
.account-item-privacy .privacy-link-btn {
  --background: transparent !important;
  --background-activated: rgba(235, 89, 82, 0.15) !important;
  --background-hover: rgba(235, 89, 82, 0.08) !important;
  --background-focused: transparent !important;
  --border-color: var(--ion-color-orange);
  --color: var(--ion-color-orange);
  --border-width: 2px;
  margin: 0;
  width: auto;
  min-height: 36px;
  height: 36px;
  flex-shrink: 0;
  font-weight: 600;
  font-size: 14px;
}
.account-item-privacy .privacy-link-btn .button-native {
  background: transparent !important;
  color: var(--ion-color-orange) !important;
}
.account-item-privacy .privacy-link-btn .button-inner {
  color: var(--ion-color-orange) !important;
}

.account-sessions-block {
  width: min(420px, 90vw);
  max-width: 100%;
  margin-bottom: 1em;
}

.account-sessions-title {
  display: block;
  margin-bottom: 0.5em;
}

.account-sessions-hint {
  font-size: 0.85em;
  color: rgba(255, 255, 255, 0.9);
  margin: 0.5em 0;
}

.account-sessions-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.account-session-item {
  background-color: white;
  border-radius: 10px;
  padding: 0.5em 1em;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  opacity: 0.95;
}

.account-session-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.account-session-device {
  font-weight: 600;
  font-size: 0.9em;
  color: #222;
}

.account-session-date {
  font-size: 0.8em;
  color: #555;
}

.account-session-revoke {
  margin: 0;
  font-size: 0.8rem;
  --color: var(--ion-color-medium);
}
</style>